import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import DonutChart from '../SemiDonutChart';
import researchIcon from '../imgs/research_icon.png';

const StrategyScalesDescription = ({ user, background, number }) => {
  // sub-scales
  const { AP_SUB_SUM } = user;

  const AP_SUB = (parseInt(AP_SUB_SUM) / 30) * 100;
  // const ES_SUB = (parseInt(ES_SUB_SUM) / 30) * 100;
  // const EL_SUB = (parseInt(EL_SUB_SUM) / 30) * 100;
  // console.log({ AP_SUB, ES_SUB, EL_SUB });

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>4.2. Escalas de estrategias de estudio</h2>
          <p className='justified'>
            Junto con tener las motivaciones adecuadas para estudiar, es
            importante que utilices estrategias de estudio que te ayuden a
            cumplir tus objetivos. Las estrategias de estudio son las distintas
            formas o métodos que usamos para estudiar y aprender. Pueden incluir
            actividades como memorizar, hacer resúmenes, organizar los tiempos
            de estudio, etc. Hay estrategias que pueden ser más útiles que otras
            para el logro de tus objetivos. En esta escala, bajo{' '}
            <strong>
              20% se considera un puntaje <em>bajo</em>, y 80% hacia arriba se
              considera un puntaje <em>alto</em>
            </strong>
            . A continuación se muestran tus principales estrategias de estudio,
            de acuerdo a tus respuestas en el test:
          </p>
          <br />
          <h3>4.2.1. Estrategias de aprendizaje profundo</h3>
          <div className='graph-in-text'>
            <div className='chart-col'>
              <div
                className='ability-icon'
                style={{
                  height: 150,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={researchIcon}
                  alt='icon'
                  style={{ height: '100%', width: 'auto' }}
                />
              </div>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
              <DonutChart
                height={120}
                barSize={42}
                fontSize={36}
                data={[
                  {
                    id: 'AP_SUB',
                    label: AP_SUB.toFixed(0) + '%',
                    value: AP_SUB,
                    color: '#f7c033'
                  }
                ]}
              />
              <p className='justified'>
                Son estrategias de estudio que aseguran un{' '}
                <strong>
                  mayor aprendizaje profundo y duradero en el tiempo
                </strong>
                . Se relacionan con técnicas para ordenar las ideas (como hacer
                resúmenes o mapas conceptuales) y relacionar los contenidos de
                distintas temáticas o asignaturas. También se relaciona con
                buscar más información cuando algo no se entiende bien, o
                simplemente parece interesante.{' '}
                <strong>
                  Este tipo de estrategias son muy útiles para un buen
                  aprendizaje, siempre y cuando se complementen con una buena
                  planificación y organización del tiempo.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default StrategyScalesDescription;
